import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import icons from "../../../assets/images/constantIcons";
import { useDispatch, useSelector } from "react-redux";
import { getItemsDetails } from "../Items/ItemsSlice";
import Select from "react-select";
import { handleError } from "../../Common/ApiCommon/ApiService";
import { addComboOffer } from "./ComboSlice";
import images from "../../../assets/images/constantImages";

const AddComboForm = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { items = [], loading } = useSelector((state) => ({
    items: state.items.items,
  }));

  useEffect(() => {
    dispatch(getItemsDetails());
  }, [dispatch]);


  const itemOptions = items?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      combo_items: [],
      price: "",
      meal_type: "",
      status: "active",
      image: null,
      imagePreview: null,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Combo name is required"),
      price: Yup.number()
        .typeError("Price must be a number")
        .positive("Must be positive")
        .required("Price is required"),
      status: Yup.string().required("Status is required"),
      image: Yup.mixed().required("Combo image is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const formData = new FormData();
        formData.append("canteen_combo_offer[combo_offer_name]", values.name);
        formData.append("canteen_combo_offer[combo_description]", values.description);
        formData.append("canteen_combo_offer[price]", values.price);
        formData.append("canteen_combo_offer[status]", values.status.toLowerCase());
        formData.append("canteen_combo_offer[combo_offer_image]", values.image);
        formik.values.combo_items.forEach((id) => {
          formData.append("canteen_combo_offer[combo_item_ids][]", id);
        });
        const response = await dispatch(addComboOffer(formData)).unwrap();
        if (response.status === 201) {
          onClose();
          resetForm();
          toast.success(response.data.message, { duration: 2000 });
        }
      } catch (errors) {
        handleError(errors)
      }
    }
  });

  if (loading) return <p>Loading ...</p>
  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Create New Combo</h2>
            <div
              className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px]"
              onClick={onClose}
            >
              <icons.IoClose className="text-green700" />
            </div>
          </div>

          <form
            onSubmit={formik.handleSubmit}
            className="space-y-4 h-[70vh] overflow-y-auto vertical"
          >
            <div className="text-G300">
              <label className="block text-sm font-normal mb-2">
                Combo Name
              </label>
              <input
                type="text"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="inputtext"
                placeholder="Burger Meal"
              />
              {formik.touched.name && formik.errors.name && (
                <div className="text-red text-sm">{formik.errors.name}</div>
              )}
            </div>

            <div className="text-G300">
              <label className="block text-sm font-normal mb-2">
                Combo Description
              </label>
              <input
                type="text"
                name="description"
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="inputtext"
                placeholder="Includes burger, fries, and drink"
              />
            </div>


            <div className="text-G300">
              <label className="block text-sm font-normal mb-2">Combo Items</label>
              <Select
                isMulti
                options={itemOptions}
                isLoading={loading}
                value={itemOptions?.filter((option) =>
                  formik.values.combo_items.includes(option.value)
                )}
                onChange={(selectedOptions) => {
                  const selectedIds = selectedOptions?.map((option) => option.value);
                  formik.setFieldValue("combo_items", selectedIds);
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select combo items"
              />
            </div>

            <div className="flex gap-4 text-G300">
              <div className="flex-1">
                <label className="block text-sm font-normal mb-2">Price</label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-3 flex items-center text-green font-semibold">
                    ₹
                  </span>
                  <input
                    type="number"
                    name="price"
                    value={formik.values.price}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onWheel={(e) => e.target.blur()}
                    className="inputtext text-green placeholder:text-green"
                    placeholder="0"
                    style={{ paddingLeft: "25px" }}
                  />
                </div>
                {formik.touched.price && formik.errors.price && (
                  <div className="text-red text-sm">{formik.errors.price}</div>
                )}
              </div>
              <div className="flex-1">
                <label className="block text-sm font-normal mb-2">Status</label>
                <select
                  name="status"
                  value={formik.values.status}
                  onChange={formik.handleChange}
                  className="inputtext"
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>
            <div className="flex items-start justify-between gap-10 text-G300">
              <div className="text-G300">
                <label className="block text-sm font-normal mb-2">Combo Image</label>
                <div
                  className="flex gap-3 items-center cursor-pointer w-20"
                  onClick={() => document.getElementById('fileInput').click()}
                >
                  <img
                    src={formik.values.imagePreview || images.downloadimage}
                    alt="Product Preview"
                    className="w-12 h-12 object-cover rounded "
                  />
                  <p>Upload</p>
                </div>
                <input
                  id="fileInput"
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={(e) => {
                    const file = e.currentTarget.files[0];
                    if (file) {
                      formik.setFieldValue("image", file);
                      formik.setFieldValue("imagePreview", URL.createObjectURL(file));
                      formik.validateField("image");
                    }
                  }}
                />
                {formik.touched.image && formik.errors.image && (
                  <div className="text-red text-sm">{formik.errors.image}</div>
                )}
              </div>


            </div>

            <button
              type="submit"
              disabled={formik.isSubmitting}
              className={`w-full mt-6 h-11 text-lg text-center py-2 rounded-lg font-semibold transition-all ${formik.isSubmitting
                  ? "bg-green200 cursor-not-allowed"
                  : "bg-green text-white hover:bg-green700"
                }`}
            >
              {formik.isSubmitting ? "Creating..." : "Create New Combo"}
            </button>
          </form>
        </div >
      </div >
    )
  );
};

export default AddComboForm;
